import React from 'react'
import { GridLayoutProps } from './Interfaces'
import { Device, useDevice } from '@confer/lib'
import MobileGridLayout from './MobileGridLayout'
import DesktopGridLayout from './DesktopGridLayout'

function GridLayout(props: GridLayoutProps) {
  const device = useDevice()

  switch (device) {
    case Device.MOBILE:
      return <MobileGridLayout {...props} />
    case Device.TABLET:
    case Device.COMPUTER:
      return <DesktopGridLayout {...props} />
  }
}

export default GridLayout
